import { K2DigioRecord, K2DigioStatus } from "../types/digio/K2Digio";

export const normalizeDigioRecord = (record: K2DigioRecord): K2DigioRecord => record;

export const isDigioSigningComplete = (status?: K2DigioStatus): boolean =>
  status === "SIGNED" || status === "LINKED";

export const shouldUseDigioSignedA2FormApi = (
  isDigioA2FormFlowEnabled: boolean,
  status?: K2DigioStatus
): boolean => isDigioA2FormFlowEnabled && isDigioSigningComplete(status);

export const isDigioSignLinkSent = (status?: K2DigioStatus): boolean => status === "AWAITING_SIGN";

export const isDigioSignedLater = (record?: K2DigioRecord | null): boolean =>
  record?.status === "DO_LATER";

export const getDigioIdentifier = (record: K2DigioRecord): string => {
  if (record.sendType === "email") {
    return record.email ?? "";
  }
  return record.phone ?? "";
};

export const hasDigioEsignApiResponse = (record?: K2DigioRecord | null): boolean => Boolean(record);

export const hasDigioEsignData = hasDigioEsignApiResponse;

export const isPurposeCodeAllowedForDigio = (
  allowedPurposeCodes: string | undefined,
  purposeCode: string | undefined
): boolean => {
  if (!allowedPurposeCodes?.trim() || !purposeCode) {
    return false;
  }

  return allowedPurposeCodes
    .split(",")
    .map((code) => code.trim())
    .filter(Boolean)
    .includes(purposeCode);
};
